/* Public production installer hosted on Vercel Blob. Update this one URL when a new signed build ships. */
window.NVL_INSTALLER_URL = 'https://wdpiyotik1jpclyv.public.blob.vercel-storage.com/NVL-Tweaks-Setup.exe';
